/* Keep standalone Matcha immediately after Original in existing flavour pickers. */
(() => {
  'use strict';
  if (window.alMatchaOrderLoaded) return;
  window.alMatchaOrderLoaded = true;

  function flavour(value) {
    const name = String(value || '').trim().replace(/\s+/g, ' ')
      .replace(/^(?:パウチ|トラベルパック)\s*[/／]\s*/, '').toLowerCase();
    if (name === 'matcha' || name === '抹茶') return 'matcha';
    if (name === 'original' || /^オリジナル(?:[（(]モカ[）)])?$/.test(name)) return 'original';
    return '';
  }

  function moveGroups(selector, getName) {
    const groups = new Map();
    document.querySelectorAll(selector).forEach(node => {
      const siblings = groups.get(node.parentElement) || [];
      siblings.push(node);
      groups.set(node.parentElement, siblings);
    });
    groups.forEach(nodes => {
      const original = nodes.find(node => flavour(getName(node)) === 'original');
      const matcha = nodes.find(node => flavour(getName(node)) === 'matcha');
      if (original && matcha && original.nextElementSibling !== matcha) original.after(matcha);
    });
  }

  function reorder() {
    const focused = document.activeElement;
    function titleText(node) {
      const title = node.querySelector('.g-pdp-options-product-title');
      return title ? Array.from(title.childNodes).filter(child => child.nodeType === 3).map(child => child.textContent).join('') : '';
    }
    moveGroups('.g-pdp-options-blocks > .g-pdp-options-product', titleText);
    moveGroups('.g-pdp-options-blocks > .g-pdp-options-product-freegift', node =>
      titleText(node).trim().replace(/^【無料特典】/, '').split('｜')[0].trim().replace(/・アダプトラテ$/, ''));
    moveGroups('.second-step-item[data-flavour-option]', node => node.dataset.flavourOption);
    moveGroups('.al-trial-flavour[data-flavour]', node => node.dataset.flavour);
    moveGroups('.al-trial-double-product[data-double-paid]', node => node.dataset.doublePaid);
    moveGroups('.al-trial-double-product[data-double-gift]', node => node.dataset.doubleGift);
    moveGroups('.al-pdp1-flavour-v2__thumb[data-flavour-name]', node => node.dataset.flavourName);

    document.querySelectorAll('variant-radios fieldset').forEach(fieldset => {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const original = inputs.find(input => flavour(input.value) === 'original');
      const matcha = inputs.find(input => flavour(input.value) === 'matcha');
      if (!original || !matcha) return;
      const labels = Array.from(fieldset.querySelectorAll('label'));
      const originalLabel = labels.find(label => label.htmlFor === original.id);
      const matchaLabel = labels.find(label => label.htmlFor === matcha.id);
      if (!originalLabel || !matchaLabel || originalLabel.nextElementSibling === matcha) return;
      originalLabel.after(matcha);
      matcha.after(matchaLabel);
    });
    document.querySelectorAll('variant-selects select').forEach(select => {
      const options = Array.from(select.options);
      const original = options.find(option => flavour(option.value) === 'original');
      const matcha = options.find(option => flavour(option.value) === 'matcha');
      if (!original || !matcha || original.nextElementSibling === matcha) return;
      const selected = Array.from(select.selectedOptions);
      original.after(matcha);
      options.forEach(option => { option.selected = selected.includes(option); });
    });
    if (focused && focused.isConnected && document.activeElement !== focused) focused.focus({ preventScroll: true });
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; reorder(); });
  }
  function start() {
    reorder();
    // Reapply after Shopify section redraws and picker replacements; never reset selection.
    const picker = '.g-pdp-options-blocks,.second-step-item,.al-trial-flavours,.al-trial-double-product,.al-pdp1-flavour-v2__thumb-row,variant-radios,variant-selects';
    new MutationObserver(records => {
      if (records.some(record => {
        if (record.target.nodeType === 1 && record.target.closest(picker)) return true;
        return Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(picker) || node.querySelector(picker)));
      })) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
